import { Requests } from '@nx-smartmonkey/shared/helpers';
import { BinTypes } from '../../domain/analytics/BinTypes';
import {
  DateChartAnalytics,
  DateChartAnalyticsProps,
} from '../../domain/analytics/dataChartAnalytics/DateChartAnalytics';
import { StopAnalyticsDateChartData } from '../../domain/analytics/stopAnalyticsDateChartData/StopAnalyticsDateChartData';
import { StopAnalyticsDateChartDataDTO } from '../../domain/analytics/stopAnalyticsDateChartData/StopAnalyticsDateChartDataDTO';
import { DateChartAnalyticsMapper } from '../../mappers/analytics/DateChartAnalyticsMapper';
import { StopAnalyticsMapper } from '../../mappers/analytics/StopAnalyticsMapper';
import { SessionRepository } from '../session/SessionRepository';
import { AnalyticsRepository } from './AnalyticsRepository';

export class AnalyticsRepositoryApi implements AnalyticsRepository {
  constructor(private requests: Requests, private sessionRepository: SessionRepository) {}

  async getAnalyticsEmissions({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<DateChartAnalytics[]> {
    const response = await this.requests.get({
      uri: `/analytics/drivers/emissions`,
      params: {
        start_date: startDate,
        end_date: endDate,
        bin_type: binType,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
    const data = response.data as DateChartAnalyticsProps[];

    return data.map(DateChartAnalyticsMapper.toDomain);
  }

  async getAnalyticsDistance({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<DateChartAnalytics[]> {
    const response = await this.requests.get({
      uri: `/analytics/drivers/distance`,
      params: {
        start_date: startDate,
        end_date: endDate,
        bin_type: binType,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
    const data = response.data as DateChartAnalyticsProps[];

    return data.map(DateChartAnalyticsMapper.toDomain);
  }

  async getAnalyticsStops({
    startDate,
    endDate,
    binType,
  }: {
    startDate: Date;
    endDate: Date;
    binType: BinTypes;
  }): Promise<StopAnalyticsDateChartData[]> {
    const response = await this.requests.get({
      uri: `/analytics/drivers/stops`,
      params: {
        start_date: startDate,
        end_date: endDate,
        bin_type: binType,
      },
      headers: await this.sessionRepository.getAuthenticationHeader(),
    });
    const data = response.data as StopAnalyticsDateChartDataDTO[];

    return StopAnalyticsMapper.toDomain(data);
  }
}
